const dateRangeFilterItems = [
  {
    label: "Today",
    value: "daily",
  },
  {
    label: "This Week",
    value: "weekly",
  },
  {
    label: "This Month",
    value: "monthly",
  },
];

export default dateRangeFilterItems;
